'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface EnrollmentModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const EnrollmentModal = ({ isOpen, onClose, children }: EnrollmentModalProps) => {
  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black/50 z-40 transition-opacity duration-300"
        onClick={onClose}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div className="bg-card rounded-2xl shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto border border-primary/10">
          {/* Header */}
          <div className="sticky top-0 bg-card border-b border-primary/10 p-6 flex items-center justify-between">
            <h2 className="text-xl font-headline font-bold text-foreground">Get Started with VitiQuest</h2>
            <button
              onClick={onClose}
              className="p-1 hover:bg-background rounded-lg transition-colors"
              aria-label="Close modal"
            >
              <Icon name="XMarkIcon" size={24} variant="outline" className="text-muted-foreground" />
            </button>
          </div>

          {/* Content */}
          <div className="p-8">
            {children}
          </div>
        </div>
      </div>
    </>
  );
};

export default EnrollmentModal;
